import { useContext } from 'react';

import { UserContext, UserContextValues } from './context';

export const useUser = (): UserContextValues => {
  const context = useContext(UserContext);

  if (context == null) {
    throw new Error('useUser must be used within an UserProvider');
  }

  return context;
};
